<template>
	<div class="index">
		<div class="indexBanner">
			<banner v-if="bannerList.length" :bgs="bannerList">
			</banner>
		</div>
		<div class="bounds" v-if="detail.realSlogan">
			<img class="slogan" :src="detail.realSlogan" />
		</div>

		<div v-if="detail.companyProfileFlag=='Y'" class="info" ref="info">
			<div class="bounds">
				<h2>{{detail.title}}</h2>
				<h2>{{detail.subTitle}}</h2>
				<p>{{detail.summary}}</p>
				<div class="flex-between ">
					<div class="item" v-for="item in adlist">
						<el-image :src="item.realThumbnail" fit="cover"></el-image>
						<a target="_blank" :href="menuUrl(item)">
							<p><span>{{item.menuName}}</span></p>
						</a>
					</div>
				</div>
			</div>
		</div>

		
		<div class="videobox" v-if="videoList.length>0">
			<div class="bounds">
				<GHtitle title="视频中心" class="tit" desc="video center"></GHtitle>
				<p class="more ter"><a href="/video" target="_blank">查看更多&gt;&gt;</a></p>
				<div class="flex-between videoview" :class="{'video2':videoList.length==2}">
					<div :class="[{'bigvideo':videoList.length==1,
										'videos':videoList.length==2,
										'video':videoList.length>2},videoList.length>2?'video'+i:'']" v-for="item,i in videoList">
						<el-image :src="item.cover" fit="cover"></el-image>
						<!-- <el-image :src="item.cover" fit="cover"></el-image> -->
						<!-- filePath -->
						<!-- <a target="_blank" :href="menuUrl(item)">
							<p><span>{{item.title}}</span></p>
						</a> -->
						<el-icon @click.native="playAction(item.filePath)" name="video-play" class="play"></el-icon>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="detail.newsFlag=='Y'" class="today bounds">
			<GHtitle :title="detail.newsTitle" class="tit" :desc="detail.newsSubTitle"></GHtitle>
			<div class="flex-between">
				<div v-for="item in newsList" class="box">
					<div class="title">{{item.menuName}}</div>
					<ul>
						<li v-for="ite in item.news">
							<a target="_blank"
								:href="'/detail?id='+ite.contentId+'&mid='+item.menuId">{{ite.title}}<span>{{dateformart(ite.createTime)}}</span></a>
						</li>
					</ul>
					<p><a target="_blank"
							:href="(item.menuType=='2'? '/notice?id=' :'/news?id=')+item.menuId">查看更多&gt;&gt;</a></p>
				</div>
			</div>
		</div>
		<div v-if="detail.coreFlag=='Y'" class="system" :style="'background-image:url('+ detail.realCoreBackground+')'">
			<div class="bounds" v-if="detail.coreInfoList&&detail.coreInfoList.length">
				<div class="sTitle">
					<GHtitle :title="detail.coreTitle" class="tit" :desc="detail.coreSubTitle"></GHtitle>
					<h2>{{detail.coreSummary}}</h2>
				</div>
				<ul class="flex-between tec" :class="{'padding':platesCount==2}">
					<li v-for="item,index in detail.coreInfoList" v-if="index<platesCount" :class="'item'+index">
						<div class="frent">
							<img v-if="index==0" src="../assets/one.png" />
							<img v-if="index==1" src="../assets/two.png" />
							<img v-if="index==2" src="../assets/three.png" />
							<span>{{item.title}}</span>
						</div>
						<div class="bg">{{item.content}}</div>
					</li>
				</ul>
				<ul class="flex-between tec" :class="{'padding':platesCount==2}" v-if="detail.coreInfoList.length>platesCount">
					<li v-for="item,index in detail.coreInfoList" 
					v-if="index>(platesCount-1)&&index<platesCount*2" 
					:class="'item'+index">
						<div class="frent">
							<img v-if="index==platesCount" src="../assets/service.png" />
							<img v-if="index==(platesCount+1)" src="../assets/yunying.png" />
							<img v-if="index==(platesCount+2)" src="../assets/chanye.png" />
							<span>{{item.title}}</span>
						</div>
						<div class="bg">{{item.content}}</div>
					</li>
				</ul>
			</div>
			<img v-else :src="detail.realCoreBackground" style="width: 100%;" />
		</div>

		<div v-if="detail.newsFlag=='Y'&& videoList.length>0" class="today bounds">
			<GHtitle :title="detail.newsTitle" class="tit" :desc="detail.newsSubTitle"></GHtitle>
			<div class="flex-between">
				<div v-for="item in newsList" class="box">
					<div class="title">{{item.menuName}}</div>
					<ul>
						<li v-for="ite in item.news">
							<a target="_blank"
								:href="'/detail?id='+ite.contentId+'&mid='+item.menuId">{{ite.title}}<span>{{dateformart(ite.createTime)}}</span></a>
						</li>
					</ul>
					<p><a target="_blank"
							:href="(item.menuType=='2'? '/notice?id=' :'/news?id=')+item.menuId">查看更多&gt;&gt;</a></p>
				</div>
			</div>
		</div>

		<div v-if="detail.subsidiaryFlag=='Y'">
			<investing :detail="detail"></investing>
		</div>

		<ul class="floatLayer" v-if="detail.email && detail.email.length>0" :class="{'show':screenTop}">
			<li class="mail"><a target="_blank" :href="detail.email">邮箱</a></li>
			<li @click="scrollToTop" class="backtop"><img src="../assets/backtop.png" /></li>
		</ul>

		<el-dialog :visible.sync="playing" center width="80%">
			<video-player ref="videoplayer" style="width: 100%; height: 100%; object-fit: fill"
				class="video-player vjs-big-play-centered" :options="playerOptions"></video-player>

		</el-dialog>
	</div>
</template>

<script>
	import {
		videoPlayer
	} from 'vue-video-player'

	import 'video.js/dist/video-js.css'
	import moment from "moment"
	import banner from "@/components/banner"
	import GHtitle from "@/components/GHtitle"
	import investing from "@/components/investing"
	export default {
		components: {
			banner,
			GHtitle,
			investing,
			videoPlayer
		},
		data() {
			return {
				detail: {},
				newsids: [],
				newsList: [],
				videoList: [],
				player: null,
				adlist: [],
				screenTop: false,
				playing: false,
				playerOptions: {
					autoplay: false, // 如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频(如果浏览器支持)
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字(例如"16:9"或"4:3")
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。

					hls: true,
					notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						fullscreenToggle: true // 全屏按钮
					},
				}
			}
		},
		mounted() {
			let self = this
			window.addEventListener('scroll', function(event) {
				let scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				if (self.$refs.info) {
					self.screenTop = scrollTop > self.$refs.info.offsetTop
				}
			})
		},
		computed: {
			bannerList() {
				let arr = []
				if (this.detail.bannerRealList) {
					this.detail.bannerRealList.forEach(item => {
						arr.push(item.url)
					})
				}
				return arr
			},
			platesCount() { 
				if(this.detail.coreInfoList&&this.detail.coreInfoList.length==4){ 
					return 2
				}
				return 3
			},
			menus() {
				return this.$store.getters.menus;
			},
			newsArr() {
				let arr = this.menus;
				let ids = this.newsids
				let ads = this.detail.fastTrack ? this.detail.fastTrack.split(',') : []
				let temp = []
				let adarr = []
				arr.forEach(item => {
					if (ids.includes(item.menuId + '')) {
						let tempitem = {
							...item
						}
						temp.news = []
						temp.push(tempitem)
					}
					if (ads.includes(item.menuId + '')) {
						adarr.push(item)
					}
					item.children.forEach(ite => {
						if (ids.includes(ite.menuId + '')) {
							let tempitem = {
								...ite
							}
							temp.news = []
							temp.push(tempitem)
						}
						if (ads.includes(ite.menuId + '')) {
							adarr.push(ite)
						}
					})
				})
				this.adlist = adarr;
				temp.sort((a, b) => {
					return ids.indexOf(a.menuId + '') - ids.indexOf(b.menuId + '')
				})
				return temp
			}
		},
		watch: {
			newsArr() {
				let temp = this.newsArr
				if (!temp.length) {
					return
				}
				let axarr = []
				temp.forEach(item => {
					axarr.push(this.axios.get('siteContent/list?pageSize=3&menuId=' + item.menuId))
				})
				if (axarr.length) {
					this.axios.all(axarr).then(res => {
						if (res && res.length == temp.length) {
							let arr = []
							temp.forEach((item, i) => {
								let temp = {
									...item
								}
								temp.news = res[i].rows
								arr.push(temp)
							})
							this.newsList = arr
						}
					}).catch(e => {})
				}
			},
			playing(val) {
				if (!val) {
					this.$refs.videoplayer.player.pause()
				}
			}
		},
		created() {
			const self = this
			this.get('siteHomeProfile/info', {}, res => {
				if (res.state) {
					self.detail = res.data   
					// 测试代码
					// let arr = [...res.data.coreInfoList,...res.data.coreInfoList]
					// self.detail.coreInfoList = arr.slice(0,4) 
					
					if (self.detail && self.detail.newsList) {
						self.newsids = self.detail.newsList.split(',')
					}
				}
			})
			this.get('siteVideo/webTopList', {
				pageNum: 1,
				pageSize: 3
			}, res => {
				if (res.state) {
					this.videoList = res.rows
					// this.videoList = [...res.rows, ...res.rows]
				}
			})
		},
		methods: {
			dateformart(date) {
				return moment(date).format('YYYY-MM-DD')
			},
			playAction(url) {
				let option = {...this.playerOptions}
				option.autoplay = true 
				option.sources = [{
					type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
					src: url // url地址
				}]
				
				this.playerOptions = option
				// this.$refs.videoPlayer.player.requestFullscreen()
				this.playing = true
			},
			scrollToTop() {
				document.documentElement.scrollTop = 0;
				document.body.scrollTop = 0
			},
			menuUrl(item) {
				if (item.children && item.children.length > 0) {
					item = item.children[0]
				}
				return this.$pageUrl(item)
			},
		}
	}
</script>
<style>
	.el-dialog__wrapper .el-dialog__header {
		display: none;
	}

	.el-dialog__wrapper .el-dialog__body {
		height: 500px;
	}

	.el-dialog__body .video-js.vjs-fluid {
		height: 500px;
		padding-top: 0;
	}
	
	@media screen and (max-width: 750px) {  
		.el-dialog__wrapper .el-dialog__body,
		.el-dialog__body .video-js.vjs-fluid { 
			height: 70vw;
		}
	}
	
	
</style>
<style scoped>
	.slogan {
		width: 100%;
	}

	/deep/ .indexBanner .banner {
		height: 54rem;
	}

	.info {
		padding: 5.7rem 0 8.57rem;
		background-color: #F9F9F9;
		color: #000;
	}

	.info h2 {
		font-size: 2.57rem;
		font-weight: bold;
		padding-bottom: 0.4rem;
	}

	.info p {
		padding-top: 2rem;
		font-size: 1.43rem;
		padding-bottom: 3.57rem;
	}

	.info img {
		width: 50.57rem;
		height: 29.29rem;
	}

	.info .item {
		position: relative;
		width: 49%;
	}

	.info .item p {
		height: 6.35rem;
		padding: 0;
		line-height: 6.35rem;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		background: linear-gradient(20deg, rgba(189, 142, 117, 0.8) 0%, rgba(224, 234, 255, 0) 100%);
	}

	.info .item p::after {
		content: "";
		display: block;
		position: absolute;
		background: url('../assets/jt.png') no-repeat;
		background-size: 100%;
		width: 5rem;
		height: 2.5rem;
		top: 2rem;
		right: 4.5rem;
	}

	.info .item span {
		padding: 0 2.14rem;
		color: #fff;
		font-size: 1.71rem
	}

	.info .item .el-image {
		height: 24rem;
		width: 100%;
	}

	.today {
		padding-bottom: 8.57rem;
	}

	.today .box {
		box-sizing: border-box;
		width: 32%;
		box-shadow: 0 0 0.5rem #eee;
		padding: 3.8rem 1.4rem;
	}

	.today .box .title {
		border-left: 0.57rem #BD8E75 solid;
		height: 2rem;
		padding-left: 1.14rem;
		line-height: 2rem;
		font-size: 1.71rem;
		font-weight: bold;
	}

	.today .box ul {
		padding: 3rem 1.7rem 2rem;
		line-height: 2rem;
	}

	.today .box li {
		font-size: 1.4rem;
		height: 4rem;
		font-weight: bold;
		position: relative;
		padding-right: 8.5rem;

		margin-bottom: 2rem;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.today .box span {
		font-size: 1;
		color: #999;
		position: absolute;
		right: 0;
		top: 0;
		font-weight: normal;
	}

	.today .box p {
		padding-left: 1.7rem;
		font-weight: bold;
		font-size: 1.29rem
	}

	.today .box p a {
		color: #BD8E75;
	}

	.videobox {
		padding-bottom: 8.57rem;
	}

	.videobox .more a {
		color: #BD8E75;
		font-size: 1.25rem;
	}

	.videoview {
		display: flex;
		justify-content: center;
		margin-top: 1.25rem;
		position: relative;
		height: 36rem;
	}

	.videoview.video2 {
		height: 26rem;
	}

	.videoview .play {
		position: absolute;
		left: 50%;
		top: 50%;
		cursor: pointer;
		color: #fff;
		margin-left: -2rem;
		margin-top: -2rem;
		font-size: 4rem;
	}

	.videoview .el-image,
	.videoview img {
		border-radius: 8px;
		width: 100%;
		height: 100%;
	}

	.videoview .bigvideo {
		width: 80%;
		height: 100%;
		display: flex;
		justify-content: center;
		position: relative;
	}

	.videoview .videos {
		overflow: hidden;
		width: 48%;
		margin-right: 40%;
		height: 100%;
		margin: 0 20px;
		position: relative;
	}

	.videoview .video0 {
		width: 59%;
		height: 36rem;
		bottom: 0;
		overflow: hidden;
		position: absolute;
		left: 0;
	}

	.videoview .video1 {
		width: 40%;
		position: absolute;
		top: 0;
		right: 0;
		height: 17.5rem;
		overflow: hidden;
	}

	.videoview .video2 {
		width: 40%;
		position: absolute;
		bottom: 0;
		right: 0;
		height: 17.5rem;
		overflow: hidden;
	}

	.videos .list {
		display: flex;
	}

	.system {
		background: #ede3de;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		overflow: hidden;
	}

	.system .bounds {
		padding-bottom: 8rem;
	}

	.system .item0 {
		background: url('../assets/sysindexbg2.png') bottom left no-repeat #fff;
		background-size: 64%;
	}

	.system .item1 {
		background: url('../assets/sysindexbg3.png') bottom left no-repeat #fff;
		background-size: 64%;
	}

	.system .item2 {
		background: url('../assets/sysindexbg1.png') bottom left no-repeat #fff;
		background-size: 64%;
	}
	.system .item3 {
		background: url('../assets/yunyingb.png') bottom left no-repeat #fff;
		background-size: 55%;
	}
	.system .item4 {
		background: url('../assets/chanyeb.png') bottom left no-repeat #fff;
		background-size: 55%;
	}
	.system .item5 {
		background: url('../assets/serviceb.png') bottom left no-repeat #fff;
		background-size: 55%;
	}

	.system .sTitle { 
	}

	.system .sTitle h1 {
		padding-top: 7rem;
		font-weight: 500;
		color: #000000;
		line-height: 1.95rem;
		font-size: 3rem;
	}

	.system .sTitle p {
		padding-top: 1rem;
		font-weight: 600;
		color: #999;
		line-height: 1.95rem;
		font-size: 1.1rem;
	}

	.system .sTitle h2 {
		font-weight: 600;
		color: #000000;
		line-height: 1.95rem;
		font-size: 1.5rem;
		text-indent: 2em;
	}

	.system ul {
		padding: 8rem;
		padding-bottom: 0;
		box-sizing: border-box;
		width: 100%;
		justify-content: center;
	}
	.system ul.padding li{
		width: 40%;
		margin: 0 5rem;
	}
	.system ul.padding{
		
	}
	.system li {
		width: 32%;
		position: relative;
		background-color: #fff;
		border-radius: 1rem;
		padding: 2.5rem 1.5rem;
		margin: 0 1rem;
		padding-top: 0;
		box-sizing: border-box;
		box-shadow: #999 0 0 0.5rem;
	}

	.system li .bg {
		color: #999;
		font-size: 1.1rem;
		line-height: 1.6rem;
		text-align: left;
		text-indent: 2rem;
	}

	.system li img {
		width: 2.3rem;
		height: 2.3rem;
		position: relative;
		top: .4rem;
		margin-right: 1rem;
	}

	.system li span {
		border-left: #e6e6e6 solid 1px;
		padding-left: 1rem;
	}

	.system .frent {
		padding: 3rem 0;
		font-size: 1.71rem;
		transition-duration: .5s;
		opacity: 1;
	}

	.floatLayer {
		background-color: #BD8E75;
		color: #fff;
		padding: .4rem 1.8rem;
		position: fixed;
		top: 50%;
		right: 0;
		margin-top: -15rem;
		text-align: center;
		display: none;
	}

	.floatLayer.show {
		display: block;
	}

	.floatLayer li {
		padding: 2.8rem 1rem;
	}

	.floatLayer .mail a {
		color: #fff;
	}

	.floatLayer .mail {
		position: relative;
		padding: 2.65rem 0rem 2.65rem 2rem;
		background: url('../assets/mail.png') left center no-repeat;
		background-size: 2.1rem;
		font-size: 1.2rem;
		text-align: right;
	}

	.floatLayer .mail::after {
		content: "";
		display: block;
		width: 80%;
		left: 10%;
		bottom: 0;
		height: 1px;
		background-color: #fff;
		position: absolute;
	}

	.floatLayer .backtop img {
		width: 3.75rem;
		height: 3.75rem;
	}

	@media screen and (max-width: 1200px) {
		.floatLayer.show {
			display: none;
		}

		.system .bounds {
			padding-bottom: 4rem;
		}

		.system ul {
			padding: 4rem;
			padding-bottom: 0;
		}

	}


	@media screen and (max-width: 750px) {
		>>>.indexBanner .banner {
			height: 16rem;
		}

		.info .item .el-image {
			height: 12rem;
		}
 

		.info {
			padding: 2.5rem 1.25rem;
		}

		.info h2 {
			font-size: 1.4rem;
			padding-bottom: 1rem;
		}

		.info p {
			font-size: 1rem;
			padding-bottom: 1rem;
		}

		.info .flex-between {
			justify-content: space-between;
		}

		.info .item {
			overflow: hidden;
		}

		.info .item img {
			height: 18rem;
		}

		.info .item p {
			height: 4rem;
			line-height: 4rem;
		}

		.info .item p::after {
			top: 1rem;
			right: 1.5rem;
		}

		.videobox {
			padding: 2rem 1rem;
		}

		.videoview {
			height: 20rem;
		}

		.videoview .video0 {
			height: 20rem;
		}

		.videoview .video1 {
			height: 9.5rem;
		}

		.videoview .video2 {
			height: 9.5rem;
		}

		.videoview.video2 {
			height: 16rem;
		}

		.today {
			padding-bottom: 1rem;
		}

		.today .tit {
			display: block;
			padding: 4rem 0;
		}

		.today .flex-between {
			display: block;
			padding: 0 10px;
		}

		.today .box {
			width: 100%;
			padding: 2rem 1.24rem;
			margin-bottom: 2rem;
		}

		.today .box li {
			margin-bottom: 1rem;
			height: 4rem;
		}

		.system {
			height: auto;
		}

		.system h2 {
			padding: 2rem;
		}

		.system ul {
			top: 18rem;
			display: block;
			text-align: left;
			font-size: 1.2rem;
			padding: 3rem;
			padding-bottom: 0;
		}

		.system .item2 {
			margin-bottom: 0;
		}

		.system .bounds {
			padding-bottom: 3rem;
		}


		.system ul li {
			width: 100%;
			margin-bottom: 2rem;
			box-shadow: #000 0 0 0;
		}

		.system .frent {
			padding: 1rem 0;
			font-size: 1.5rem;
		}

		.system .frent span {
			border: none;
			margin: 0;
			padding: 0;
		}

		.system li img {
			display: none;
		}

		.system .item0,
		.system .item1,
		.system .item2,
		.system .item3,
		.system .item4,
		.system .item5 {
			background: #fff;
		}
		
		>>> .videobox .title{
			display: block;
			padding:1rem 0;
		}
	}
</style>